import { LegendDatum } from '@nivo/waffle'

type LegendDatumWithPercentage = LegendDatum & { percentage: number }

interface LegendProps {
  data: LegendDatumWithPercentage[]
  onItemClick: (id: string | number) => void
}

export const Legend = ({ data, onItemClick }: LegendProps) => {
  return (
    <div className="flex w-full flex-col">
      {data.map((item) => (
        <div
          key={item.id}
          onClick={() => onItemClick(item.id)}
          className="flex w-full cursor-pointer flex-row items-center">
          <div className="h-4 w-4 rounded-full" style={{ backgroundColor: item.color }} />
          <div className="flex w-fit max-w-[calc(100%-1rem)] flex-row items-center gap-2 rounded-md px-2 py-0.5 hover:bg-gray-100">
            <p className="truncate text-left text-sm">{item.label}</p>
            <span className="w-fit text-sm text-gray-500">{item.percentage.toFixed(2)}%</span>
          </div>
        </div>
      ))}
    </div>
  )
}
